module.exports = __webpack_public_path__ + "img/center012.ae1507d0.jpg";